module.exports = __webpack_public_path__ + "img/shipo-menu-facility-checklist-performance.d3347e11.svg";